import React, { useState, useEffect } from "react";
// import JSONPretty from "react-json-pretty";
import { connect } from "react-redux";
import { Input } from "../../../revvComponents";
import { RevvForm } from "../../../commonComponents";

import {
  MetaFieldInitialValuesMap,
  MetaFieldComponentRules,
  MetaFieldComponentMessages,
} from "./MetaFieldRulesMap";

// Actions Imports
import { DocumentTemplateActions } from "../../../actions";

const {
  toggleDynamicFieldView,
  // setMetaFieldValues,
  setFlagForDefault,
  metaValidStatus,
} = DocumentTemplateActions;

const MetaFieldSingleLineText = props => {
  const [singleLineTextFieldValues, getDataForPrepopulateData] = useState([]);
  const [showDefaultValue] = useState(true);
  const getDataForPrepopulate = propsData => {
    let returnData = JSON.parse(
      JSON.stringify(MetaFieldInitialValuesMap.SINGLE_LINE_TEXT),
    );
    if (propsData.meta && propsData.meta.default) {
      returnData = propsData.meta;
    }
    getDataForPrepopulateData(returnData);
  };
  useEffect(() => {
    props.setFlagForDefault(true);
    getDataForPrepopulate(props);
  }, [props]);

  // _getShowDefaultValue = propsData => {
  //   let returnData = false;
  //   if (propsData.meta && propsData.meta.default) {
  //     returnData = true;
  //   }
  //   return returnData;
  // };

  // _toggleDefaultValue = () => {
  //   const { showDefaultValue } = this.state;
  //   this.setState({ showDefaultValue: !showDefaultValue });
  //   this.props.setFlagForDefault(!showDefaultValue);
  // };

  // render() {
  //   const { showDefaultValue, singleLineTextFieldValues } = this.state;
  console.debug("Common field values");
  console.debug(singleLineTextFieldValues);
  return (
    <React.Fragment>
      {(showDefaultValue || true) && (
        <RevvForm
          initialFormValue={singleLineTextFieldValues}
          customFieldName="SINGLE_LINE_TEXT"
          customFieldComponentRules={MetaFieldComponentRules}
          customFieldComponentMessages={MetaFieldComponentMessages}
          render={formProps => {
            const {
              handleChange,
              handleBlur,
              messages,
              touched,
              errors,
              values,
              isValid,
            } = formProps;
            const allInAll = {
              isValid,
              messages,
              touched,
              errors,
              values,
            };
            console.debug("allInAll", allInAll);
            if (isValid) {
              // props.metaValidStatus(true);
              props.setMetaFieldValues(values);
            } else {
              // props.metaValidStatus(false);
              props.setMetaFieldValues({});
            }
            return (
              <React.Fragment>
                <div className="dynamicfieldcustom-revvform">
                  <span className="revvform-label">
                    Default value
                    {/* <span className="requiredwitherr-input"> *</span> */}
                  </span>
                  <Input
                    id="default"
                    name="default"
                    data-test="SingleLineTextField-default"
                    type="text"
                    value={values && values.default}
                    placeholder="Enter field default value"
                    className="metafield-create-input errorborder"
                    onChange={value => handleChange(value)}
                    onBlur={value => handleBlur(value)}
                    // required
                  />
                  {/* {allInAll.messages.default && (
                    <ErrorMessages
                      messages={allInAll.messages.default.required}
                    />
                  )} */}
                </div>
              </React.Fragment>
            );
          }}
        />
      )}
    </React.Fragment>
  );
  // }
};

const mapStateToProps = state => {
  const { meta } =
    state.TemplateStore.dynamicFields.selectedDynamicFieldForUpdate;
  return {
    meta,
  };
};

const mapDispatchToProps = {
  toggleDynamicFieldView,
  setFlagForDefault,
  metaValidStatus,
  // setMetaFieldValues,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MetaFieldSingleLineText);
